import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export interface FiscalYear {
  id: string
  company_ID?: string
  companyId?: string
  name: string
  startDate: string
  endDate: string
  isClosed: boolean
  closedDate?: string
  closedBy?: string
  notes?: string
}

interface FiscalYearState {
  selectedFiscalYear: FiscalYear | null
  setSelectedFiscalYear: (fiscalYear: FiscalYear | null) => void
  clearSelectedFiscalYear: () => void
}

export const useFiscalYearStore = create<FiscalYearState>()(
  persist(
    (set) => ({
      selectedFiscalYear: null,
      setSelectedFiscalYear: (fiscalYear) => set({ selectedFiscalYear: fiscalYear }),
      clearSelectedFiscalYear: () => set({ selectedFiscalYear: null }),
    }),
    {
      name: 'fiscal-year-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
)

